// Skeleton.js - Placeholders animados para estados de carga
import React from 'react';
import '../styles/skeleton/Skeleton.css';

export const Skeleton = ({ width, height, borderRadius = '6px', className = '' }) => (
  <div
    className={`skeleton ${className}`.trim()}
    style={{
      width: width || '100%',
      height: height || '1em',
      borderRadius
    }}
    aria-hidden="true"
  />
);

export const SkeletonEventCard = () => (
  <div className="skeleton-event-card">
    <Skeleton height="200px" borderRadius="12px 12px 0 0" className="skeleton-image" />
    <div className="skeleton-event-body">
      <Skeleton height="22px" width="85%" />
      <Skeleton height="16px" width="50%" />
      <Skeleton height="16px" width="65%" />
    </div>
  </div>
);

export const SkeletonTableRow = ({ cols = 6 }) => (
  <tr className="skeleton-table-row">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i}>
        <Skeleton height="20px" width={i === 0 ? '60%' : '80%'} />
      </td>
    ))}
  </tr>
);

export const SkeletonRecordsTable = ({ rows = 5, showFilters = false }) => (
  <div className="skeleton-records-wrap">
    {showFilters && (
      <div className="skeleton-filters">
        <Skeleton height="36px" width="120px" />
        <Skeleton height="36px" width="100px" />
        <Skeleton height="36px" width="140px" />
      </div>
    )}
    <table className="skeleton-table">
      <thead>
        <tr>
          {['Categoría', 'Tipo', 'Atleta', 'Valor (kg)', 'Lugar', 'Fecha'].map((h, i) => (
            <th key={i}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, i) => (
          <SkeletonTableRow key={i} cols={6} />
        ))}
      </tbody>
    </table>
  </div>
);

export default Skeleton;
